import React from "react";
import "./cta.css";
const Cta = () => {
  return (
    <div className="gpt_cta section-margin">
      <div className="gpt_content">
        <p>Request Early Access to Get Started</p>
        <h3>Register today & start exploring the endless possiblities.</h3>
      </div>
      <button class="cta-btn">Get Started</button>
    </div>
  );
};

export default Cta;
